<template>
    <div>
        <b-form @submit="getCustomersBySearch">
            <b-input-group>
                <b-input-group-prepend>
                    <b-input-group-text>
                        <i v-if="!form.isBusy" class="fa-solid fa-search"></i>
                        <i v-else class="fa-solid fa-spin fa-spinner"></i>
                    </b-input-group-text>
                </b-input-group-prepend>

                <b-form-input  v-model="form.searchQuery"
                               id="customer_search_input_header"
                               type="text"
                               @focus="inputFocus"
                               @input="deBounce"
                               placeholder="Search for customer, order, email, phone, etc">

                </b-form-input>


                <b-popover ref="search_input_popover"
                           target="customer_search_input_header"
                           :show.sync="form.isOpen"
                           placement="bottom"
                           id="search-popover"
                           custom-class="p-0"
                           triggers="manual">

                    <b-table id="intake-outstanding-results"
                             ref="inputResultTable"
                             small
                             hover
                             striped
                             class="mb-0"
                             tbody-tr-class="text-center pointer"
                             head-variant="dark"
                             no-provider-paging
                             no-provider-sorting
                             no-provider-filtering
                             :fields="form.fields"
                             show-empty
                             @row-clicked="goToOrder"
                             :items="form.items">
                        <template v-slot:head(actions)="data">
                        </template>

                        <template v-slot:cell(full_name)="data">
                            <div>{{data.item.first_name}} {{data.item.last_name}} ({{data.item.email}})</div>
                        </template>
                        <template v-slot:cell(order_id)="data">
                            <div>{{ data.item.orders && data.item.orders.data && data.item.orders.data.length ? data.item.orders.data[data.item.orders.data.length-1].id : 'Unknown' }}</div>
                        </template>
                    </b-table>

                </b-popover>


            </b-input-group>
        </b-form>
    </div>
</template>

<script>
    import LoadingSpinner from '@/components/LoadingSpinner';
    import _ from 'lodash';
    export default {
        name: 'HeaderSearch',
        components: {LoadingSpinner},
        data() {
            return {
                form: {
                    searchQuery: null,
                    order_id: null,
                    isBusy: false,
                    isOpen: false,
                    awaitingSearch: false,
                    cancelToken: undefined,
                    items: [],

                    fields: [
                        {key: 'id', label: 'Customer #', class: 'text-center'},
                        {key: 'order_id', label: 'Order #', class: 'text-center'},
                        {key: 'full_name', label: 'Name', class: 'text-center'},
                        //{key: 'address', label: 'Address', class: 'text-center'},
                        //'actions',
                    ],
                },
            }
        },
        created: function() {
            window.addEventListener('click', this.closeSearchDropDown);
        },
        methods: {
            closeSearchDropDown() {
                this.inputFocus();
            },
            inputFocus() {
                this.form.isOpen = false;
            },
            getCustomersBySearch(event) {
                if(event) {
                    event.preventDefault();
                }
                if (this.form.searchQuery && this.form.isBusy == false) {
                    this.form.isBusy = true;
                    this.form.isOpen = false;
                    let that = this;
                    this.form.searchQuery = this.$barcodeScanner.parseBarcode(this.form.searchQuery);

                    if (typeof this.form.cancelToken != typeof undefined) {
                        this.form.cancelToken.cancel('New search initiated');
                    }
                    this.form.cancelToken = this.$http.CancelToken.source();
                    this.$http.get('/search/customers', {
                        params: {
                            q: this.form.searchQuery
                        },
                        cancelToken: this.form.cancelToken.token
                    }
                    ).then(response => {
                        let final = [];
                        let toSeperate = response.data.data;
                        toSeperate = toSeperate.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at) );

                        for (var i = 0; i < toSeperate.length; i++) {
                            toSeperate[i].created_at = new Date(toSeperate[i].created_at);
                            let orders = toSeperate[i].orders.data;
                            for (let j = 0; j < orders.length; j++) {
                                let order = orders[j];
                                let build = _.cloneDeep(toSeperate[i]);
                                build.latest_order = order;
                                build.orders.data = [order];
                                final.push(build);
                            }
                        }

                        this.form.items = final;
                        that.form.isBusy = false;
                        that.form.isOpen = true;
                    }).catch((thrown) => {
                        if (this.$http.isCancel(thrown)) {
                            console.log('Request canceled', thrown.message);
                        } else {
                            // handle error
                        }
                    });
                }
            },

            goToOrder(customer) {
                if (customer.orders && customer.orders.data && customer.orders.data.length != 0) {
                    let order = customer.orders.data[customer.orders.data.length - 1];
                    this.$router.replace({
                        path: '/kit/view/' + order.id,
                    });
                    this.form.isOpen = false;
                    //this.$router.go(0); #No longer nessassary
                }
            },
            deBounce: _.debounce(function() {
                if(this.form.searchQuery.length > 4) {
                    this.form.isBusy = false;
                    this.getCustomersBySearch(null);
                } else if (this.form.searchQuery.length == 0 && typeof this.form.cancelToken != typeof undefined) {
                    this.form.cancelToken.cancel('New search initiated');
                    this.form.isOpen = false;
                    this.form.isBusy = false;
                } else {
                    this.form.isOpen = false;
                    this.form.isBusy = false;
//                    this.$refs.search_input_popover.$emit('close');
                }
            }, 500)
        }
    };
</script>

<style>
    .popover-body {
        padding: 0 !important;
    }
    #search-popover {
        min-width: 500px !important;
        overflow-y: scroll !important;
        max-height: 500px !important;
    }

</style>
